<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import api from "@/axios";
import CustomStore from "devextreme/data/custom_store";
import Swal from "sweetalert2";
import {
  DxColumn,
  DxColumnChooser,
  DxColumnFixing, DxDataGrid, DxExport,
  DxFilterRow,
  DxGrouping, DxGroupPanel, DxPager,
  DxRemoteOperations,
  DxStateStoring, DxSelection
} from "devextreme-vue/data-grid";
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";
import DropZone from "@/components/widgets/dropZoneTexto.vue";
import Multiselect from "@vueform/multiselect";
import { ref } from "vue";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager, DxFilterRow, DxRemoteOperations, DxSelection,
    Loader, DropZone, Multiselect
  },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop };
  },
  data() {
    moment.locale('pt-br');
    return {
      title: "Extrato Financeiro",
      items: [
        {
          text: "Financeiro",
          href: "/"
        },
        {
          text: "Extrato Financeiro",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      loading: false,

      empresaData: null,

      clienteData: null,
      dtListPesqCli: null,
      loadingCliente: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      filterMode: 'month',
      selectedMonthDate: moment().format('YYYY-MM'),
      selectedTipo: 'Todos',
      searchTerm: '',
      selectedConta: 'Todos',
      selectedBanco: 'Todos',
      idselected: 0,
      isProcessing: false,
      currentTab: 'caixa',
      tabCurrentData: null,
      uploadedBanks: [],

      showModalFileExtrato: false,
      submittedFileExtrato: false,
      financeiroData: {},
      dtListPesqConta: null,
      ContaData: null,
      loadingConta: false,
      ultdataatt: "",
      
      
      nroContas: [],
      // maiorLancto: null,
      seriesGraph: null,
      chartOptions: null,
      periodo: null,
      saldo: 0,
      saldoLimite: 0,
      saldoExtrato: 0,
      totalCredito: 0,
      totalDebito: 0,
      totalTransacoes: 0,
      extrato: {},
      transacoes: [],
      listDebitos: [],
      listCreditos: [],
      dataListFinanceiro: null,
      showModalAssocFinanceiro: false,
      tipoFinanPesq: null,
      loadingList: false,
      boletoAssociacoes: [],
    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    },
    
    filteredTransactions() {
      if (this.selectedTipo === 'Todos') {
        return this.tabCurrentData || []
      } else if (this.selectedTipo === 'Credito') {
        return this.listCreditos || []
      } else if (this.selectedTipo === 'Debito') {
        return this.listDebitos || []
      }
      return []
    },
  },

  mounted() {
    console.log('mounted extratoConsolidado')
    console.log(this.dtIniFiltro, this.dtFimFiltro) 

    this.carregarDados()
  },

  methods: {
    nomeStatusBaixaGrid(baixa) {
      switch (baixa?.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AB':
          return 'Em Aberto'
        case 'AG':
          return 'Agendado'
        case 'QT':
          return 'Quitado'
      }
      return baixa.value
    },

    confirmAssocFinanceiro() {
      console.log('confirmAssocFinanceiro')
      console.log(`Tipo da operação: ${this.tipoFinanPesq}`)

      const idsFinanParc = this.dataGrid.getSelectedRowKeys()
      console.log('idsFinanParc: ' + JSON.stringify(idsFinanParc))

      //console.log('dataList: ' + JSON.stringify(this.dataListFinanceiros))

      if (this.tipoFinanPesq === 'P') {
        console.log('totalizando pagamentos')
        let extrato = this.listDebitos.find((item) => {
          return item.id === this.extratoSelectedID
        })
        console.log('extrato encontrado: ' + JSON.stringify(extrato))
        console.log('valor extrato: ' + extrato.valor)

        let financeiros = []
        this.dataListFinanceiros.forEach((item) => {
          if (idsFinanParc.includes(item.finanparc_id)) {
            //console.log('adding item: ' + JSON.stringify(item))
            financeiros.push(item)
          }
        })

        //console.log('financeiros: ' + JSON.stringify(financeiros))

        /**
         * Totalizando valores financeiros
         */
        let totalFinanceiros = 0
        financeiros.forEach((item) => {
          totalFinanceiros += parseFloat(item.finanparc_valor)
        })
        console.log(`totalFinanceiros: ${JSON.stringify(totalFinanceiros)}`)

        this.totalPercDiffExtrFinan = (parseFloat(extrato.valor) - parseFloat(totalFinanceiros))
        console.log('totalPercDiffExtrFinan: ' + this.totalPercDiffExtrFinan)
      } else {
        console.log('totalizando recebimentos')
        let extrato = this.listCreditos.find((item) => {
          return item.id === this.extratoSelectedID
        })
        //console.log('extrato encontrado: ' + JSON.stringify(extrato))
        console.log('valor extrato: ' + extrato.valor)

        let financeiros = []
        this.dataListFinanceiros.forEach((item) => {
          if (idsFinanParc.includes(item.finanparc_id)) {
            //console.log('adding item: ' + JSON.stringify(item))
            financeiros.push(item)
          }
        })

        //console.log('financeiros: ' + JSON.stringify(financeiros))

        /**
         * Totalizando valores financeiros
         */
        let totalFinanceiros = 0
        financeiros.forEach((item) => {
          totalFinanceiros += parseFloat(item.finanparc_valor)
        })
        console.log(`totalFinanceiros: ${JSON.stringify(totalFinanceiros)}`)

        this.totalPercDiffExtrFinan = (parseFloat(extrato.valor) - parseFloat(totalFinanceiros))
        console.log('totalPercDiffExtrFinan: ' + this.totalPercDiffExtrFinan)
      }

      /*if(this.tipoFinanPesq === 'P' && idsFinanParc.length > 1) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Tipo de associação só permite 1 registro!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000
        }).then(() => {
          this.refeFormTable(this.dataGrid)
        })
      }*/

      if (this.totalPercDiffExtrFinan > 10 || this.totalPercDiffExtrFinan < (-10)) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: `Deseja realmente associar o Extrato ID: ${this.extratoSelectedID} ao registro Financeiro ID: ${idsFinanParc} ?`,
          text: `Existe uma diferença de R$${this.totalPercDiffExtrFinan.toFixed(2)} entre o Extrato e Financeiro`,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.disparaAssocExtratoFinanc(idsFinanParc)
          }
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "question",
          title: `Deseja realmente associar o Extrato ID: ${this.extratoSelectedID} ao registro Financeiro ID: ${idsFinanParc} ?`,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.disparaAssocExtratoFinanc(idsFinanParc)
          }
        })
      }

    },

    refeFormTableFinanceiro() {
      this.dataListFinanceiro.state(null)
    },

    onCellPreparedFinanceiro(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "finanparc_status") {
          const valStatus = e.data.finanparc_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'CA':
              corStatus = 'rgba(223,121,106,0.98)'
              break
            case 'CO':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'QT':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'FA':
              corStatus = 'rgba(248,178,58,0.82)'
              break
            case 'EL':
              corStatus = 'rgba(101,166,249,0.82)'
              break
            case 'AB':
              corStatus = 'rgba(248,178,58,0.82)'
              break

          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },

    onRowDblClickExtrato(e) {
      console.log('onRowDblClickExtrato')
      const data = e.data
      console.log(data)
      console.log(`tipo: ${data.financeiro_tipo}`)

      this.tipoFinanPesq = data.financeiro_tipo
      const tipoFinanPesq = this.tipoFinanPesq

      this.extratoSelectedID = data.id
      console.log('extratoSelectedID', this.extratoSelectedID)

      const self = this
      this.dataListFinanceiro = new CustomStore({
        key: "finanparc_id",
        load: function (loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'q': null,
            't': tipoFinanPesq

          }
          // console.log(paramsReq)
          return api.get(`${getBaseUrl()}api/assocfinpesq`, {
            params: paramsReq
          }).then(res => {
            console.log('then axios assocfinpesq')
            console.log(res.data)

            self.showModalAssocFinanceiro = true;
            self.dataListFinanceiros = res.data[0]

            return {
              data: res.data[0],
              totalCount: res.data[1],
            }
          })
        }
      })
    },

    carregouGridFinanceiro(e) {
      console.log('carregouGridFinanceiro')
      this.totalListFinanceiro = e.component.totalCount()
    },

    disparaAssocExtratoFinanc(idsFinanParc) {
      api.post(`${getBaseUrl()}api/associaExtratoFinanc`, {
        'idfinanparc': idsFinanParc,
        'idextrato': this.extratoSelectedID,
        'tipo': this.tipoFinanPesq
      }).then(res => {
        console.log('then axios associa extrato financeiro')
        console.log(res.data)

        this.showModalAssocFinanceiro = false

        if (res.data.sucess === true) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 3500
          }).then(() => {
            this.carregarDados()
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.carregarDados()
          })
        }
      })
    },

    carregarDados(){
      console.log('carregarDados_extratofinac')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      // console.log('filtros_localstorage', filtros)
      if (!filtros) {
        if (this.filterMode === 'month') {
          const periodo = this.getMonthPeriodFromDate(this.selectedMonthDate)
          this.dtIniFiltro = periodo.inicio
          this.dtFimFiltro = periodo.fim
        } else if (!this.dtIniFiltro && !this.dtFimFiltro) {
          this.dtIniFiltro = moment().startOf('month').format('YYYY-MM-DD')
          this.dtFimFiltro = moment().endOf('month').format('YYYY-MM-DD')
        }
        localStorage.setItem('filtros', JSON.stringify({
          'findi': this.dtIniFiltro,
          'findf': this.dtFimFiltro,
          'mode': this.filterMode,
          'month': this.selectedMonthDate
        }))
      } else {
        this.dtIniFiltro = filtros['findi']
        this.dtFimFiltro = filtros['findf']
        this.filterMode = filtros['mode'] || 'month'
        this.selectedMonthDate = filtros['month'] || moment(filtros['findi']).format('YYYY-MM')
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro && !this.selectedMonthDate) {
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      console.log('dtIniFiltro', this.dtIniFiltro)
      console.log('dtFimFiltro', this.dtFimFiltro)

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      api.get(`${getBaseUrl()}api/extrconsolidado`, {
        params: {
          'conta': this.selectedConta,
          'di': di,
          'df': df
        }
      }).then((res) => {
        console.log('then axios extrconsolidado')
        console.log(res.data)

        this.nroContas = res.data[0] ?? [];
        this.extrato = res.data[1];
        this.transacoesConsolidadas = res.data[2];
        this.transacoesTodas = res.data[3];
        this.transacoesProvisionadas = res.data[4];
        this.boletoAssociacoes = res.data[5] ?? [];

        console.log('this.boletoAssociacoes', this.boletoAssociacoes)
        if(this.selectedConta === null){
          if(this.nroContas.length > 0){
            this.selectedConta = this.nroContas[0]['numero']
          }
        }
        this.montaGrid(this.currentTab)
      });
    },

    montaGrid(tab){
      console.log('mudouExibição para:', tab)
      this.currentTab = tab;

      if (this.currentTab === 'boleto') {
        this.tabCurrentData = this.boletoAssociacoes;
      } else if (this.currentTab === 'caixa' || this.currentTab === 'provisoes' || this.currentTab === 'fluxocaixa' || this.currentTab === 'extrato') {
        this.tabCurrentData = this.currentTab === 'caixa' ? this.transacoesConsolidadas :
            this.currentTab === 'provisoes' ? this.transacoesProvisionadas :
                this.currentTab === 'fluxocaixa' ? this.transacoesTodas :
                    this.extrato;

        let listDebitosLoc = []
        let listCreditosLoc = []
        let totalDebitoConsolidado = 0
        let totalCreditoConsolidado = 0
        let countTransacoes = 0
        this.tabCurrentData.forEach((lancto) => {

          lancto.data_fmt = moment(lancto.data).format('DD/MM/YYYY')
          lancto.data = moment(lancto.data).toDate()

          const valorTrnasacao = parseFloat(lancto.valor) || 0

          if (lancto.financeiro_tipo === 'P'){
            listDebitosLoc.push(lancto)
            totalDebitoConsolidado += valorTrnasacao
          } else if (lancto.financeiro_tipo === 'R'){
            listCreditosLoc.push(lancto)
            totalCreditoConsolidado += valorTrnasacao
          }


          this.listDebitos = listDebitosLoc
          this.listCreditos = listCreditosLoc

          countTransacoes++
        })

        this.totalCredito = totalCreditoConsolidado
        this.totalDebito = totalDebitoConsolidado
        this.saldo = totalCreditoConsolidado - totalDebitoConsolidado;
        this.totalTransacoes = countTransacoes
      }
    },

    carregouGrid(){
      console.log('carregouGrid')
      // const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      // const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

    },

    /*onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
    },*/

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const status = e.data.status
          let corStatus = 'rgba(248,178,58,0.82)'
          switch (status) {
            case 'AB':
              corStatus = 'rgba(248,178,58,0.82)'
              break
            case 'PEN':
              corStatus = 'rgba(248,178,58,0.82)'
              break
            case 'QT':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'CON':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'AG':
              corStatus = 'rgba(101,166,249,0.82)'
              break
            case 'CA':
              corStatus = 'rgba(223,121,106,0.98)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }

        if (e.column.dataField === "financeiro_tipo") {
          const tipo = e.data.financeiro_tipo
          let corTipo = 'rgba(248,178,58,0.82)'
          switch (tipo) {
            case 'P':
              corTipo = 'rgba(248,178,58,0.82)'
              break
            case 'R':
              corTipo = 'rgba(46,184,134,0.96)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corTipo}`;
        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    getMonthPeriodFromDate(monthDate) {
      if (!monthDate) {
        const inicio = moment().startOf('month').format('YYYY-MM-DD');
        const fim = moment().endOf('month').format('YYYY-MM-DD');
        return { inicio, fim };
      }

      const inicio = moment(monthDate, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
      const fim = moment(monthDate, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');

      return { inicio, fim };
    },

    confirmarPeriodo(){
      if (this.filterMode === 'month') {
        const periodo = this.getMonthPeriodFromDate(this.selectedMonthDate);
        this.dtIniFiltro = periodo.inicio;
        this.dtFimFiltro = periodo.fim;
      }

      console.log('confirmarPeriodo', { 
        mode: this.filterMode, 
        inicio: this.dtIniFiltro, 
        fim: this.dtFimFiltro,
        month: this.selectedMonthDate 
      })
      
      localStorage.setItem('filtros', JSON.stringify({
        'findi': this.dtIniFiltro,
        'findf': this.dtFimFiltro,
        'mode': this.filterMode,
        'month': this.selectedMonthDate
      }))

      this.carregarDados()
    },

    formatOnlyDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },

    formatDtMonthYear(monthDate) {
      if (!monthDate) return '';
      const monthObj = moment(monthDate, 'YYYY-MM');
      const monthName = monthObj.format('MMMM');
      const year = monthObj.format('YYYY');
      return monthName.charAt(0).toUpperCase() + monthName.slice(1) + ' de ' + year;
    },

    onTipoChange(tipo) {
      this.selectedTipo = tipo;
    },

    onContaChange(id) {
      console.log('onContaChange', id)
      console.log(typeof id)
      if (id === '0') {
        this.selectedConta = 'Todos';
        this.selectedBanco = 'Todos';
        return
      }
      const conta = this.nroContas.filter(conta => conta.id === id)
      this.selectedConta = conta[0].numero;
      this.selectedBanco = conta[0].banco;
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'AB':
          return 'Aberto (AB)'
        case 'QT':
          return 'Quitado (QT)'
        case 'CA':
          return 'Cancelado (CA)'
        case 'PEN':
          return 'Pendente (PEN)'
        case 'CON':
          return 'Conciliado (CON)'
      }
      return e.value
    },

    nomeTipo(e) {
      switch (e.value) {
        case 'P':
          return 'Débito'
        case 'R':
          return 'Crédito'
      }
      return e.value
    },

    formatarNumeroParcela(e) {
      if (e.value && typeof e.value === 'string' && e.value.includes('-')) {
        const partes = e.value.split('-');
        return partes[1] + '/' + partes[0];
      }
      return e.value;
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },


    importarExtrato() {
      console.log('importarExtrato')
      this.showModalFileExtrato = true
    },

    sincronizarDados() {
      console.log("sincronizarDados")
      this.updating = true

      const periodo = moment(this.dtIniFiltro).format('YYYY-MM')
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      api.get(`${getBaseUrl()}api/financonta`, {
        params: {
          periodo: periodo,
          conta: this.selectedConta,
          banco: this.selectedBanco,
          'di': di,
          'df': df
        }
      }).then((res) => {
        console.log('then axios financonta')
        console.log(res.data)
        this.updating = false
        if (res.data.success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.carregarDados()
          })
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.data.error,
            text: 'Sincronização não realizada.',
            showConfirmButton: false,
            timer: 2500
          })
        }
      })
    },

    pesqConta(evt) {
      console.log('pesqFinConta')
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a, b) => a.codigo - b.codigo);
        });
      }
    },

    escolheuConta() {
      this.loadingConta = true;
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.financeiroData.banco_id },
      }).then((res) => {
        this.ContaData = res.data[0];
        this.loadingConta = false;
        this.financeiroData.banco_id = this.ContaData.id;
        this.financeiroData.banco = this.ContaData.banco;
      });
    },

    selectedFileExtrato() {
      console.log('selectedFileExtrato')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },

    confExtrato() {
      console.log('confExtrato')
      this.showModalFileExtrato = true
      if (this.dropzoneFile.name) {
        this.showModalFileExtrato = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        let formData = new FormData()
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)
        formData.append("banco_id", this.financeiroData.banco_id)

        api.post(`${getBaseUrl()}api/extratofilenew`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          this.updating = false
          if (res.data.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 3500
            }).then(() => {
              this.carregarDados()
            })
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.error,
              showConfirmButton: false,
              timer: 3500
            }).then(() => {
              this.carregarDados()
            })
          }
        }).catch((err) => {
          console.log('erro axios', err)
          this.updating = false
        })
      }
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="border-bottom mb-4 pb-3">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-3">
          <h1 class="h4 mb-0">Extrato Consolidado</h1>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-sm btn-outline-primary">
            <i class="mdi mdi-compare me-2"></i>
            Cruzamento
          </button>
        </div>
      </div>
    </div>

    <Loader v-if="loading" style="min-height: 300px;"></Loader>

    <div v-if="!loading">
      <div class="row mb-4">
        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="text-muted small mb-2">Total de Créditos</p>
                  <h4 class="text-success mb-0">{{ formatCurrency(this.totalCredito) }}</h4>
                </div>
                <div class="text-success" style="font-size: 2rem; opacity: 0.3;">
                  <i class="mdi mdi-arrow-bottom-left"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="text-muted small mb-2">Total de Débitos</p>
                  <h4 class="text-danger mb-0">{{ formatCurrency(this.totalDebito) }}</h4>
                </div>
                <div class="text-danger" style="font-size: 2rem; opacity: 0.3;">
                  <i class="mdi mdi-arrow-top-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="text-muted small mb-2">Saldo do Período</p>
                  <h4 :class="this.saldo >= 0 ? 'text-success' : 'text-danger'" class="mb-0">
                    {{ formatCurrency(this.saldo) }}
                  </h4>
                </div>
                <div :class="this.saldo >= 0 ? 'text-success' : 'text-danger'" style="font-size: 2rem; opacity: 0.3;">
                  <i class="mdi mdi-file-spreadsheet"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="text-muted small mb-2">Total de Transações</p>
                  <h4 class="text-primary mb-0">{{ this.totalTransacoes }}</h4>
                </div>
                <div class="text-primary" style="font-size: 2rem; opacity: 0.3;">
                  <i class="mdi mdi-receipt"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 mb-3 me-5">
                  <div class="card-body p-2 px-3">
                    <div class="row align-items-center mb-2">
                      <div class="col-md-6 border-end">
                        <label class="form-label small fw-bold mb-1">Modo de Filtro</label>
                        <div class="form-check form-switch">
                          <input 
                            class="form-check-input" 
                            type="checkbox" 
                            id="filterModeSwitch" 
                            v-model="filterMode"
                            true-value="period"
                            false-value="month"
                            @change="confirmarPeriodo()"
                          >
                          <label class="form-check-label small" for="filterModeSwitch">
                            {{ filterMode === 'month' ? 'Por Mês' : 'Por Período' }}
                          </label>
                        </div>
                      </div>

                      <div v-if="filterMode === 'month'" class="col-md-6">
                        <label class="form-label small fw-bold mb-1">Mês Selecionado</label>
                        <input 
                          v-model="selectedMonthDate" 
                          @change="confirmarPeriodo()"
                          type="month" 
                          class="form-control form-control-sm border-0 shadow-sm" 
                        />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label small fw-bold mb-1" :class="{'text-muted': filterMode === 'month'}">Início</label>
                        <input 
                          v-model="dtIniFiltro" 
                          @change="confirmarPeriodo()"
                          type="date" 
                          :disabled="filterMode === 'month'"
                          class="form-control form-control-sm border-0 shadow-sm" 
                        />
                      </div>

                      <div class="col-md-6">
                          <label class="form-label small fw-bold mb-1" :class="{'text-muted': filterMode === 'month'}">Fim</label>
                          <input 
                            v-model="dtFimFiltro" 
                            @change="confirmarPeriodo()"
                            type="date" 
                            :disabled="filterMode === 'month'"
                            class="form-control form-control-sm border-0 shadow-sm" 
                          />
                      </div>
                    </div>
                  </div>
                </div>
                 
                <div class="col-md-4 mb-3">
                  <label class="form-label small fw-bold">Conta</label>
                  <select v-model="idselected" @change="onContaChange(idselected)" class="form-select form-select-sm">
                    <option value="0">Todas as contas</option>
                    <option v-for="bank in nroContas" :key="bank.id" :value="bank.id">
                      {{ bank.descricao }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4 mb-3">
                  <label class="form-label small fw-bold">Tipo de Transação</label>
                  <select v-model="selectedTipo" @change="onTipoChange(selectedTipo)" class="form-select form-select-sm">
                    <option value="Todos">Todos</option>
                    <option value="Credito">Créditos</option>
                    <option value="Debito">Débitos</option>
                  </select>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <p class="text-muted small">
            Exibindo <span class="fw-bold text-dark">{{ this.totalTransacoes }}</span> transações
            <span v-if="filterMode === 'month'">
              em <span class="fw-bold text-dark">{{ formatDtMonthYear(selectedMonthDate) }}</span>
            </span>
            <span v-else>
              de <span class="fw-bold text-dark">{{ formatOnlyDate(dtIniFiltro) }}</span> até <span class="fw-bold text-dark">{{ formatOnlyDate(dtFimFiltro) }}</span>
            </span>
          </p>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button 
                @click="montaGrid('caixa')"
                :class="{ 'active': currentTab === 'caixa' }"
                class="nav-link"
              >
                <i class="mdi mdi-table me-2"></i>Caixa "Contas Pagar/Receber onde existe dtbaixa"
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                  @click="montaGrid('fluxocaixa')"
                  :class="{ 'active': currentTab === 'fluxocaixa' }"
                  class="nav-link"
              >
                <i class="mdi mdi-swap-vertical-bold me-2"></i>Fluxo de Caixa "Previstos + Real"
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                  @click="montaGrid('provisoes')"
                  :class="{ 'active': currentTab === 'provisoes' }"
                  class="nav-link"
              >
                <i class="mdi mdi-table-arrow-left me-2"></i>Provisões "Previstos"
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button 
                @click="montaGrid('extrato')"
                :class="{ 'active': currentTab === 'extrato' }"
                class="nav-link"
              >
                <i class="mdi mdi-file me-2"></i>Extratos
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button 
                @click="montaGrid('boleto')"
                :class="{ 'active': currentTab === 'boleto' }"
                class="nav-link"
              >
                <i class="mdi mdi-barcode me-2"></i>Boletos
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="currentTab === 'caixa'" class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <DxToolbar>
                <DxItem location="before" widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      text="Limpar filtros"
                      :on-click="refeFormTable"/>
                </DxItem>
              </DxToolbar>

              <Loader v-if="updating" style="min-height: 300px;"></Loader>

              <div v-if="!updating" class="mt-2">
                <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="filteredTransactions"
                    :keyExpr="'id'"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @cell-prepared="onCellPrepared"
                    @content-ready="carregouGrid"
                    @exporting="onExporting">

                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="true" />

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"/>
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strExtrConsolidadoList"/>

                  <DxGroupPanel :visible="true"/>
                  <DxGrouping />

                  <DxColumn sort-order="desc"
                            data-field="id"
                            caption="ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="empresa"
                            caption="Empresa"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="codigo"
                            caption="Código"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="numero"
                            caption="Número"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="pessoa_nome"
                            caption="Fornecedor"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="pessoa_cnpj"
                            caption="CNPJ"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="extrato_id"
                            caption="Extrato ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_tipo"
                            caption="Tipo"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeTipo"
                            :filter-operations="['=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="status"
                            caption="Status"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeStatus"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="financeiro_categoria"
                            caption="Categoria"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_conta"
                            caption="Conta"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="emissao"
                            caption="Emissão"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="vencimento"
                            caption="Vencimento"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="dtbaixa"
                            caption="Data Baixa"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="valor"
                            caption="Valor"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="valorqit"
                            caption="Valor QIT"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="desconto"
                            caption="Desconto"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="juros"
                            caption="Juros"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financ_id"
                            caption="Financ. ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="sequencial"
                            caption="Sequencial"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_obs"
                            caption="Observação Financeira"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="obs"
                            caption="Observação Parc."
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_id"
                            caption="Boleto ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="formapgto"
                            caption="Forma Pgto"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="livre1"
                            caption="Livre 1"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="livre2"
                            caption="Livre 2"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_livre1"
                            caption="Financeiro Livre 1"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_livre2"
                            caption="Financeiro Livre 2"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"/>

                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab === 'fluxocaixa'" class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <DxToolbar>
                <DxItem location="before" widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      text="Limpar filtros"
                      :on-click="refeFormTable"/>
                </DxItem>
              </DxToolbar>

              <Loader v-if="updating" style="min-height: 300px;"></Loader>

              <div v-if="!updating" class="mt-2">
                <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="filteredTransactions"
                    :keyExpr="'id'"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @cell-prepared="onCellPrepared"
                    @content-ready="carregouGrid"
                    @exporting="onExporting">

                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="true" />

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"/>
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strExtrConsolidadoList"/>

                  <DxGroupPanel :visible="true"/>
                  <DxGrouping />

                  <DxColumn sort-order="desc"
                            data-field="id"
                            caption="ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="empresa"
                            caption="Empresa"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="codigo"
                            caption="Código"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="numero"
                            caption="Número"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="pessoa_nome"
                            caption="Fornecedor"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="pessoa_cnpj"
                            caption="CNPJ"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="extrato_id"
                            caption="Extrato ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_tipo"
                            caption="Tipo"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeTipo"
                            :filter-operations="['=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="status"
                            caption="Status"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeStatus"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="financeiro_categoria"
                            caption="Categoria"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_conta"
                            caption="Conta"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="emissao"
                            caption="Emissão"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="vencimento"
                            caption="Vencimento"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="dtbaixa"
                            caption="Data Baixa"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="valor"
                            caption="Valor"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="valorqit"
                            caption="Valor QIT"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="desconto"
                            caption="Desconto"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="juros"
                            caption="Juros"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financ_id"
                            caption="Financ. ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="sequencial"
                            caption="Sequencial"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_obs"
                            caption="Observação Financeira"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="obs"
                            caption="Observação Parc."
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_id"
                            caption="Boleto ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="formapgto"
                            caption="Forma Pgto"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="livre1"
                            caption="Livre 1"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="livre2"
                            caption="Livre 2"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_livre1"
                            caption="Financeiro Livre 1"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_livre2"
                            caption="Financeiro Livre 2"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"/>

                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab === 'provisoes'" class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <DxToolbar>
                <DxItem location="before" widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      text="Limpar filtros"
                      :on-click="refeFormTable"/>
                </DxItem>
              </DxToolbar>

              <Loader v-if="updating" style="min-height: 300px;"></Loader>

              <div v-if="!updating" class="mt-2">
                <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="filteredTransactions"
                    :keyExpr="'id'"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @cell-prepared="onCellPrepared"
                    @content-ready="carregouGrid"
                    @exporting="onExporting">

                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="true" />

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"/>
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strExtrConsolidadoList"/>

                  <DxGroupPanel :visible="true"/>
                  <DxGrouping />

                  <DxColumn sort-order="desc"
                            data-field="id"
                            caption="ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="empresa"
                            caption="Empresa"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="codigo"
                            caption="Código"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="numero"
                            caption="Número"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="pessoa_nome"
                            caption="Fornecedor"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="pessoa_cnpj"
                            caption="CNPJ"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="extrato_id"
                            caption="Extrato ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_tipo"
                            caption="Tipo"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeTipo"
                            :filter-operations="['=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="status"
                            caption="Status"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeStatus"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="financeiro_categoria"
                            caption="Categoria"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_conta"
                            caption="Conta"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="emissao"
                            caption="Emissão"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="vencimento"
                            caption="Vencimento"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="dtbaixa"
                            caption="Data Baixa"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="valor"
                            caption="Valor"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="valorqit"
                            caption="Valor QIT"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="desconto"
                            caption="Desconto"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="juros"
                            caption="Juros"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financ_id"
                            caption="Financ. ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="sequencial"
                            caption="Sequencial"
                            alignment="center"
                            data-type="string"
                            :filter-operations="['=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_obs"
                            caption="Observação Financeira"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="obs"
                            caption="Observação Parc."
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_id"
                            caption="Boleto ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="formapgto"
                            caption="Forma Pgto"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="livre1"
                            caption="Livre 1"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="livre2"
                            caption="Livre 2"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_livre1"
                            caption="Financeiro Livre 1"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_livre2"
                            caption="Financeiro Livre 2"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"/>

                </DxDataGrid>
              </div>
            </div>
          </div>
          <!-- <div class="alert alert-info">
            <i class="mdi mdi-information me-2"></i>
            Visualização de provisões em desenvolvimento
          </div> -->
        </div>
      </div>

      <div v-if="currentTab === 'extrato'" class="row">
        <div class="col-12">
          <b-alert show variant="info">
            Se você deseja associar um extrato a um registro financeiro, dê dois cliques na linha do registro desejado.
          </b-alert>
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <DxToolbar>
                <DxItem location="before" widget="dxButton">
                  <DxButton
                    icon="refresh"
                    hint="Redefinir formatação de tabela para padrão"
                    text="Limpar filtros"
                    :on-click="refeFormTable" />
                </DxItem>
                <DxItem location="before">
                  <template #default>
                    <b-button class="mx-2" variant="outline-info" @click="importarExtrato">
                      <i class="mdi mdi-file "></i>
                      Importar Extrato
                    </b-button>
                  </template>
                </DxItem>
                <DxItem location="before">
                  <template #default>
                    <b-button class="me-2 btn btn-success" @click="sincronizarDados">
                      <i class="mdi mdi-sync"></i>
                      Sincronizar(API)
                    </b-button>
                  </template>
                </DxItem>
              </DxToolbar>

              <Loader v-if="updating" style="min-height: 300px;"></Loader>

              <div v-if="!updating" class="mt-2">
                <DxDataGrid
                  ref="dataGridRefKey"
                  :data-source="filteredTransactions"
                  :keyExpr="'id'"
                  :show-borders="true"
                  :focused-row-enabled="true"
                  :column-auto-width="true"
                  :show-row-lines="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  @exporting="onExporting"
                  @cell-prepared="onCellPrepared"
                  @content-ready="carregouGrid"
                  @row-dbl-click="onRowDblClickExtrato">

                  <DxColumnChooser :enabled="true"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="true" />

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"/>
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strExtrConsolidadoListCategoria"/>

                  <DxColumn sort-order="desc"
                            data-field="id"
                            caption="ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="financeiro_tipo"
                            caption="Tipo"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeTipo"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="data"
                            caption="Data"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy HH:mm"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="datalote"
                            caption="Data Lote"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy HH:mm"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="status"
                            caption="Status"
                            alignment="center"
                            data-type="string"
                            :customize-text="nomeStatus"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="descricao"
                            caption="Descrição"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="descricaocompl"
                            caption="Descrição Completa"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="numerodoc"
                            caption="Número Doc"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="valor"
                            caption="Valor"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="transacaoid"
                            caption="ID Transação"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="finanparc_id"
                            caption="Finanparc ID"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="ultdataatt"
                            caption="Última Atualização"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy HH:mm"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentTab === 'boleto'" class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <DxToolbar>
                <DxItem location="before" widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      text="Limpar filtros"
                      :on-click="refeFormTable"/>
                </DxItem>
              </DxToolbar>

              <Loader v-if="updating" style="min-height: 300px;"></Loader>

              <div v-if="!updating" class="mt-2">
                <DxDataGrid
                    ref="dataGridRefKeyBoleto"
                    :data-source="boletoAssociacoes"
                    :keyExpr="'id'"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @content-ready="carregouGrid"
                    @exporting="onExporting">

                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true"/>
                  <DxColumnFixing :enabled="true"/>
                  <DxFilterRow :visible="true" />

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"/>
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strBoletoAssociacaoList"/>

                  <DxGroupPanel :visible="true"/>
                  <DxGrouping />

                  <DxColumn sort-order="desc"
                            data-field="id"
                            caption="ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="finanparc_id"
                            caption="FinanParc ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="extrato_id"
                            caption="Extrato ID"
                            alignment="left"
                            data-type="number"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_valor"
                            caption="Valor Boleto"
                            alignment="right"
                            data-type="number"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="extrato_data"
                            caption="Data Extrato"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="transacaoid"
                            caption="Transação"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="banco_nome"
                            caption="Banco"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_linhadig"
                            caption="Linha Digitável"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_cbarras"
                            caption="Código de Barras"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_nossonum"
                            caption="Nosso Número"
                            alignment="left"
                            data-type="string"
                            :filter-operations="['contains', 'notcontains']"
                            :allowHeaderFiltering="false"/>

                  <DxColumn data-field="boleto_vencimento"
                            caption="Vencimento Boleto"
                            alignment="center"
                            data-type="date"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                  <DxColumn data-field="finanparc_numero"
                            caption="Número Parcela"
                            alignment="left"
                            data-type="string"
                            :customize-text="formatarNumeroParcela"
                            :filter-operations="['contains', 'notcontains']"
                            :allowHeaderFiltering="false"/>

                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"/>

                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModalAssocFinanceiro" size="xl" title="Associar financeiro/parcela" centered
      title-class="font-18"
      hide-footer>

      <div class="card">
        <h5 class="text-warning me-2" v-if="tipoFinanPesq === 'P'">Para débitos apenas 1 financeiro pode ser associado
        </h5>
        <span class="text-warning ms-3" style="margin-top: -5px">Sempre que desejar reiniciar, utilize o botão "limpar
          filtros" para garantir uma associação correta!</span>
        <div class="card-body">

          <div>
            <DxToolbar>

              <DxItem location="before" widget="dxButton">
                <DxButton icon="refresh" text="Limpar filtros" hint="Redefinir formatação de tabela para padrão"
                  :on-click="refeFormTableFinanceiro" />
              </DxItem>

              <DxItem>
                <DxButton icon="save" text="financeiro/parcela" hint="financeiro/parcela"
                  :on-click="confirmAssocFinanceiro" />
              </DxItem>
            </DxToolbar>
          </div>

          <Loader v-if="loadingList" style="min-height: 300px;">
          </Loader>

          <div class="mt-2" v-if="!loadingList">
            <DxDataGrid ref="dataGridRefKey" :data-source="dataListFinanceiro" :show-borders="true"
              :focused-row-enabled="true" :column-auto-width="true" :show-row-lines="true"
              :allow-column-reordering="true" :allow-column-resizing="true" :row-alternation-enabled="true"
              @cell-prepared="onCellPreparedFinanceiro" @content-ready="carregouGridFinanceiro">
              <!--@row-dbl-click="onRowDblClick"-->

              <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" :summary="true" :grouping="false"
                :group-paging="false" />


              <DxColumnChooser :enabled="true" />
              <DxColumnFixing :enabled="true" />
              <DxFilterRow :visible="true" />


              <DxSelection mode="multiple" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxStateStoring :enabled="true" type="sessionStorage" storage-key="strWmsOsEntradaList" />

              <DxGroupPanel :visible="true" />
              <DxGrouping />

              <DxColumn data-field="finanparc_id" caption="ID" sort-order="desc" data-type="number" alignment="right"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true" />

              <DxColumn data-field="finanparc_numero" caption="Numero" alignment="left" data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true" />

              <DxColumn data-field="finanparc_status" caption="Status" alignment="center" data-type="text"
                :customize-text="nomeStatusBaixaGrid"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true" />

              <!--              <DxColumn-->
              <!--                  data-field="financeiro_stsbaixa"-->
              <!--                  caption="Status"-->
              <!--                  alignment="center"-->
              <!--                  data-type="text"-->
              <!--                  :customize-text="nomeStatusBaixaGrid"-->
              <!--                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"-->
              <!--                  :allowHeaderFiltering="true"/>-->

              <DxColumn data-field="pessoa_nome" caption="Pessoa" data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allow-sorting="false" :allowHeaderFiltering="true" />

              <DxColumn data-field="pessoa_cnpj" caption="CNPJ" data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allow-sorting="true" :allowHeaderFiltering="true" />

              <DxColumn :width="110" data-field="finanparc_valor" caption="Valor" alignment="right" data-type="number"
                :format="formatDecimal"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allow-sorting="true" :allowHeaderFiltering="true" />

              <DxColumn data-field="finanparc_emissao" caption="Dt. Emissao" alignment="right" data-type="datetime"
                format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true" />

              <DxColumn data-field="finanparc_vencimento" caption="Dt. Vencimento" alignment="right"
                data-type="datetime" format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="true" />

              <DxPager :visible="true" :show-page-size-selector="true" :allowed-page-sizes="[10, 30, 50, 100]"
                :show-navigation-buttons="true" :show-info="true" />

            </DxDataGrid>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Arquivo Extrato CNAB240" v-model="showModalFileExtrato" centered hide-footer>
      <div>
        <div class="col-md-8 mb-3 ms-3">
          <label for="banco">Selecione a Instituição Bancária</label>
          <multiselect id="banco" @search-change="pesqConta" @select="escolheuConta" v-model="financeiroData.banco_id"
            placeholder="Selecione a Inst. Bancária" :options="dtListPesqConta" :searchable="true" label="descricao"
            class="multiselect-size" track-by="descricao" value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="font-size-10 mx-1 me-4">
                    (banco: {{ slotProps.option.banco }})
                  </span>
                  <span class="">
                    {{ slotProps.option.descricao }}
                  </span>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="card-body">
          <h4 class="card-title col-md-6">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFileExtrato" />
          <span class="file-info" v-if="dropzoneFile">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedFileExtrato && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFileExtrato = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confExtrato">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>